export const LABEL_1STLEVEL = 'ShopAccountFirstLevel';
export const LABEL_1STLEVEL_SLICE_MACHINE = '1st_level';
export const MEMBER = 'member';
export const MEMBER_MONTHLY = 'member_monthly';
export const CORPORATE_MEMBER = 'corporatemember';
export const FREE_TRIALER = 'free_trialer';
export const CHURNER = 'churner';
export const FRESH_USER = 'fresh-user';
export const ULTRA_FRESH_USER = 'ultra-fresh-user';
export const ORDER_TAG_FRESH = 'fresh';
export const ORDER_TAG_ULTRA_FRESH = 'ultra-fresh';
export const EARLY_EXPIRATION_USER = 'early-expiration-user';
export const FREE_MEMBER = 'free_member';
export const MEMBER_MALIN = 'member-malin';
export const NONE = 'none';
export const CONNECTED = 'connected';
export const SUBSCRIPTION_COMPARED_AT_PRICE = {
  fr: 69.9,
  de: 79.9,
};

export const USER_STATUS = {
  [LABEL_1STLEVEL]: '1st level',
  [MEMBER]: 'Member',
  [CORPORATE_MEMBER]: 'Corporate member',
  [FREE_TRIALER]: 'Free trialer',
  [CHURNER]: 'Churner',
  [FRESH_USER]: 'Fresh user',
  [ULTRA_FRESH_USER]: 'Ultra fresh user',
  [NONE]: 'No status',
};
